/**
 * Format a minute count into a compact, kitchen-friendly duration.
 *
 *   45  -> "45m"
 *   90  -> "1h 30m"
 *   120 -> "2h"
 *
 * Returns an empty string for null/undefined/zero so callers can treat the
 * absence of a time the same as an empty value.
 */
export const formatMinutes = (minutes: number | null | undefined): string => {
    if (minutes == null || minutes <= 0) {
        return "";
    }

    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    if (hours === 0) {
        return `${mins}m`;
    }
    if (mins === 0) {
        return `${hours}h`;
    }
    return `${hours}h ${mins}m`;
};
